import { createContext, useContext } from 'react';

import { defaultNamespace as defaults } from './default/index.js';
import { componentNamespaceFactory } from './factory.js';
import skyParallax from './sky-parallax/index.js';
import checkout from './checkout/index.js';
import skyCheckout from './sky-parallax/components/Checkout';

const namespaces = {
  defaults,
  skyParallax,
  checkout,
  skyCheckout,
};

const components = Object.entries(namespaces).reduce(
  (acc, [namespace, entries]) => ({
    ...acc,
    [namespace]: componentNamespaceFactory(entries),
  }),
  {}
);

/**
 * We map contentful types to React components for rendering. To support different
 * treatments for a given type without adding a bunch of conditional logic into the
 * components themselves, the contentful content instance may specify a component
 * namespace to indicate which React component to use.
 *
 * Components should prefer the useComponents hook below unless there's a specific
 * need to access this directly.
 *
 * @param {string} componentNamespace
 * @returns {{ string: { component: JSX.Element, guards: Function[] } }} A map of identifiers (mostly contentful type ids) to an object containing a React component and an array of guard functions.
 */
export function getComponentMap(componentNamespace) {
  return namespaces[componentNamespace] || namespaces.defaults;
}

export const ComponentContext = createContext(defaults);

export const useComponents = (namespace) => {
  const contextNamespace = useContext(ComponentContext);
  return components[namespace || contextNamespace] || components.defaults;
};
